module.exports = __webpack_public_path__ + "static/media/NNL-Fanzone.4814c69b.jpg";